import { Component } from '@angular/core';

@Component({
  selector: 'app-dialog-access-code-converting-error',
  templateUrl: './dialog-access-code-converting-error.component.html',
  styleUrls: ['./dialog-access-code-converting-error.component.scss']
})
export class DialogAccessCodeConvertingErrorComponent {
  constructor() { }
}
